/*
 * @Author: liuc
 * @Date: 2020-06-05 16:11:23
 * @Description:
 */
// * @Author: liuchang
// * @Date: 2019-08-14 20:27:01
// * @Description:

import 'babel-polyfill';
import Vue from 'vue';
import 'element-ui/lib/theme-chalk/index.css';
import 'element-ui/lib/theme-chalk/reset.css';
import './assets/css/element-variables.scss';
import ElementUI from 'element-ui';
import Icon from 'vue-svg-icon/Icon.vue';
import './assets/css/global.scss';
import App from './App';
import router from './router';
import api from '@/services/api.js';
import '@/utils/global.js';
import store from './store/index';
import Qs from 'qs';
import './assets/css/screenAdaptation1366.scss';
import './assets/css/screenAdaptation1920.scss';
import Base64 from 'js-base64';
import './assets/icon/iconfont.css';
import animated from 'animate.css';
import moment from 'moment';
import _ from 'lodash';
// markdown 编辑器
import publicMethods from './public/public.js';
import Sortable from 'sortablejs';
import {Toast, Confirm} from 'wc-messagebox';
import 'wc-messagebox/style.css';
import {parseDateTime} from '@/utils/YKScope.js';
Vue.use(Toast);
Vue.use(Confirm);
Vue.use(publicMethods);
Vue.prototype.$api = api;
Vue.prototype.$Qs = Qs;
Vue.prototype.$Base64 = Base64;
Vue.prototype.$moment = moment;
Vue.prototype.$parseDateTime = parseDateTime;
Vue.use(animated);
Vue.component('icon', Icon);
Vue.use(ElementUI);
Vue.prototype.$Sortable = Sortable;
// eslint-disable-next-line no-new
Vue.directive('scroll-to-bottom', {
    inserted: function (el) {
        el.scrollTop = el.scrollHeight;
    },
    update: function (el) {
        el.scrollTop = el.scrollHeight;
    }
});
new Vue({
    el: '#app',
    router,
    store,
    components: { App },
    template: '<App/>'
});



// WEBPACK FOOTER //
// ./src/main.js